import React from "react";
import SlidingIconButton from "./SlidingIconButton";

interface ShareViaEmailButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ShareViaEmailButton: React.FC<ShareViaEmailButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <SlidingIconButton
      color="text-white"
      text="Verstuur via mail"
      iconClass="d-send"
      className="w-[9.5rem] hover:border-sunshineYellow"
      onClick={onClick}
      openByDefault={true}
      reverse={false}
      disabled={disabled}
    />
  );
};

export default ShareViaEmailButton;
